export default __webpack_public_path__ + "static/media/head-back.78a994f2.png";